import { a as a$1 } from './chunk-XCSSTYD2.mjs';
import { create } from 'zustand';

var a=create(a$1);

export { a };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=chunk-XRQWUMZ2.mjs.map